import { Pipe, PipeTransform } from '@angular/core';
import { FacetUrlService } from '@df/module-facet-url/core/facet-url.service';

/**
 * Usage
 *
 * {{model.name | facetOverride : category.id : 'h1' }}
 */
@Pipe({
    name: 'facetOverride',
    standalone: true,
    pure: false
})
export class FacetOverridePipe implements PipeTransform {
    constructor(private facetUrlService: FacetUrlService) {}

    transform<T>(defaultValue: T, categoryId: number, property: string) {
        const facetData = this.facetUrlService.retrieveFacetData(categoryId);
        if (facetData?.hasOwnProperty(property)) {
            return facetData[property];
        }
        return defaultValue;
    }
}
